module.exports = __webpack_public_path__ + "img/part5-19.4e55d1df.png";